import React, { useState, useEffect } from 'react';
import { getDevices, createDevice, updateDevice, deleteDevice } from '../../services/api';
import { useNavigate } from 'react-router-dom';

function ManageDevicesScreen() {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ DeviceID: null, MacAddress: '', Description: '' });
  const navigate = useNavigate();
  const restaurantId = localStorage.getItem('restaurantId'); // Obter o ID do restaurante logado
  // TODO: Obter o RegisteredByUserID do token de autenticação do admin do restaurante
  const registeredByUserId = 1; // Placeholder

  useEffect(() => {
    if (!restaurantId) {
      setError('ID do restaurante não encontrado. Faça login novamente.');
      setLoading(false);
      return;
    }
    fetchDevices();
  }, [restaurantId]);

  const fetchDevices = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getDevices();
      setDevices(data);
    } catch (err) {
      console.error('Failed to fetch devices:', err);
      setError('Não foi possível carregar os dispositivos.');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!restaurantId) {
      setError('ID do restaurante não encontrado. Faça login novamente.');
      return;
    }

    try {
      const deviceData = {
        MacAddress: form.MacAddress,
        Description: form.Description,
        RestaurantID: restaurantId,
        RegisteredByUserID: registeredByUserId,
      };

      if (form.DeviceID) {
        await updateDevice(form.DeviceID, deviceData);
      } else {
        await createDevice(deviceData);
      }
      setForm({ DeviceID: null, MacAddress: '', Description: '' }); // Limpar formulário
      fetchDevices(); // Recarregar lista
    } catch (err) {
      console.error('Failed to save device:', err);
      setError('Falha ao salvar dispositivo. Verifique os dados.');
    }
  };

  const handleEdit = (device) => {
    setForm({
      DeviceID: device.DeviceID,
      MacAddress: device.MacAddress,
      Description: device.Description,
    });
  };

  const handleDelete = async (deviceId) => {
    setError('');
    if (window.confirm('Tem certeza que deseja excluir este dispositivo?')) {
      try {
        await deleteDevice(deviceId);
        fetchDevices();
      } catch (err) {
        console.error('Failed to delete device:', err);
        setError('Falha ao excluir dispositivo.');
      }
    }
  };

  if (loading) {
    return <div style={styles.loading}>Carregando dispositivos...</div>;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Gerenciar Dispositivos</h2>
      <button onClick={() => navigate('/restaurant/dashboard')} style={styles.backButton}>
        Voltar ao Painel
      </button>

      <div style={styles.formSection}>
        <h3>{form.DeviceID ? 'Editar Dispositivo' : 'Adicionar Novo Dispositivo'}</h3>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            type="text"
            name="MacAddress"
            placeholder="Endereço MAC (ex: AA:BB:CC:DD:EE:FF)"
            value={form.MacAddress}
            onChange={handleChange}
            style={styles.input}
            required
          />
          <input
            type="text"
            name="Description"
            placeholder="Descrição (ex: Tablet Garçom 1)"
            value={form.Description}
            onChange={handleChange}
            style={styles.input}
            required
          />
          <button type="submit" style={styles.submitButton}>
            {form.DeviceID ? 'Salvar Alterações' : 'Adicionar Dispositivo'}
          </button>
          {form.DeviceID && (
            <button type="button" onClick={() => setForm({ DeviceID: null, MacAddress: '', Description: '' })} style={styles.cancelButton}>
              Cancelar Edição
            </button>
          )}
        </form>
      </div>

      <div style={styles.listSection}>
        <h3>Lista de Dispositivos</h3>
        {devices.length === 0 ? (
          <p>Nenhum dispositivo cadastrado.</p>
        ) : (
          <ul style={styles.list}>
            {devices.map((device) => (
              <li key={device.DeviceID} style={styles.listItem}>
                <span>{device.Description} ({device.MacAddress})</span>
                <div style={styles.actions}>
                  <button onClick={() => handleEdit(device)} style={styles.editButton}>Editar</button>
                  <button onClick={() => handleDelete(device.DeviceID)} style={styles.deleteButton}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    backgroundColor: '#f0f2f5',
    minHeight: '100vh',
    fontFamily: 'Arial, sans-serif',
  },
  title: {
    color: '#333',
    marginBottom: '20px',
  },
  backButton: {
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginBottom: '20px',
  },
  formSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    marginBottom: '20px',
    width: '100%',
    maxWidth: '600px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '10px',
    marginBottom: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px',
  },
  submitButton: {
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  cancelButton: {
    backgroundColor: '#ffc107',
    color: '#333',
    border: 'none',
    borderRadius: '4px',
    padding: '10px 15px',
    cursor: 'pointer',
    marginTop: '10px',
  },
  listSection: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    padding: '20px',
    width: '100%',
    maxWidth: '600px',
  },
  list: {
    listStyle: 'none',
    padding: 0,
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 0',
    borderBottom: '1px solid #eee',
  },
  actions: {
    display: 'flex',
    gap: '10px',
  },
  editButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 12px',
    cursor: 'pointer',
  },
  deleteButton: {
    backgroundColor: '#dc3545',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 12px',
    cursor: 'pointer',
  },
  loading: {
    fontSize: '18px',
    color: '#555',
    marginTop: '50px',
  },
  error: {
    color: 'red',
    marginBottom: '10px',
    textAlign: 'center',
  },
};

export default ManageDevicesScreen;
